module.exports = __webpack_public_path__ + "static/xxpeed-xp-2-b741a1c6204fb9ff717ab4e63832b885.jpg";